import { Status } from "../../../assets/data/Constants";
import {
  ITkViewButtonJudgementflowType,
  ITkViewButtonJudgementStatus,
} from "../../../type/componentsType/TkViewButtonJudgement";

type ButtonOptionsType = {
  [key in ITkViewButtonJudgementStatus]: {
    [key in ITkViewButtonJudgementflowType]: string;
  };
};

export const buttonOptions: ButtonOptionsType = {
  [Status["届出待ち"]]: {
    TYPE1: "申請",
    TYPE2: "申請",
    TYPE3: "申請",
    TYPE4: "申請",
  },
  [Status["受理待ち"]]: {
    TYPE1: "契約者に差戻し,受理",
    TYPE2: "契約者に差戻し,受理",
    TYPE3: "契約者に差戻し,受理",
    TYPE4: "",
  },
  [Status["再受理待ち"]]: {
    TYPE1: "契約者に差戻し,受理",
    TYPE2: "契約者に差戻し,受理",
    TYPE3: "契約者に差戻し,受理",
    TYPE4: "",
  },
  [Status["稟議決裁結果待ち"]]: {
    TYPE1: "担当者に差戻し,拒絶,承認",
    TYPE2: "担当者に差戻し,承認",
    TYPE3: "",
    TYPE4: "",
  },
  [Status["課長代理確認待ち"]]: {
    TYPE1: "担当者に差戻し,課長代理確認",
    TYPE2: "担当者に差戻し,課長代理確認",
    TYPE3: "担当者に差戻し,課長代理確認",
    TYPE4: "",
  },
  [Status["課長代理確認拒絶待ち"]]: {
    TYPE1: "担当者に差戻し,課長代理拒絶確認",
    TYPE2: "",
    TYPE3: "",
    TYPE4: "",
  },
  [Status["上長承認待ち"]]: {
    TYPE1: "担当者に差戻し,上長承認",
    TYPE2: "担当者に差戻し,上長承認",
    TYPE3: "担当者に差戻し,上長承認",
    TYPE4: "",
  },
  [Status["上長承認拒絶待ち"]]: {
    TYPE1: "担当者に差戻し,上長拒絶承認",
    TYPE2: "",
    TYPE3: "",
    TYPE4: "",
  },
  [Status["通知待ち"]]: {
    TYPE1: "通知",
    TYPE2: "通知",
    TYPE3: "通知",
    TYPE4: "",
  },
  [Status["通知拒絶待ち"]]: {
    TYPE1: "拒絶通知",
    TYPE2: "",
    TYPE3: "",
    TYPE4: "",
  },
  [Status["契約者差戻し中"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["郵送待ち"]]: {
    TYPE1: "郵送",
    TYPE2: "郵送",
    TYPE3: "郵送",
    TYPE4: "郵送",
  },
  [Status["郵送拒絶待ち"]]: { TYPE1: "郵送", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["処理完了"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["処理拒絶完了"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["取下済"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["差戻し一時保存"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
  [Status["添付待ち"]]: { TYPE1: "", TYPE2: "", TYPE3: "", TYPE4: "" },
};
